/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiResponse {
  /**
   * 응답 코드 (0=성공, 그 외=오류)
   * @default 0
   */
  code: number;
  /** 응답 데이터 */
  data: Record<string, any>;
  /** 응답 메시지. 응답 코드가 0이 아닌 경우 오류 메시지. */
  message: string;
}

export interface ServiceSetting {
  /**
   * 서비스 설정 아이디
   * @example "6646c5042444062a6de18ba3"
   */
  _id: string;
  /**
   * 샘플 여부
   * @example false
   */
  isSample?: boolean;
  /**
   * 서비스 설정 이름
   * @example "기본 서비스 설정"
   */
  name?: string;
  /** 치료 카테고리 목록 */
  treatmentCategories?: TreatmentCategoryWithTreatmentCaution[];
  /**
   * 첫 방문 및 시작 날짜 사용 여부
   * @example false
   */
  usingFirstVisitStartDate?: boolean;
  /**
   * 자동화 정책 SINGLE, MULTIPLE
   * @example "MULTIPLE"
   */
  automationPolicy?: "SINGLE" | "MULTIPLE";
  /**
   * 차트 번호 사용 여부
   * @example false
   */
  usingChartNumber?: boolean;
  /** 국가 코드 사용 여부 */
  usingCountryCode?: boolean;
  /** 생일 사용 여부 */
  usingBirthDay?: boolean;
  /** 성별 사용 여부 */
  usingGender?: boolean;
  /** 치료 태그 사용 여부 */
  usingTreatmentTag?: boolean;
  /** 국적 사용 여부 */
  usingNationality?: boolean;
  /**
   * 비디오 자동 전송 여부
   * @example false
   */
  autoSendVideo?: boolean;
  /** 사용할 비디오 콘텐츠 목록 */
  usingAutoSendVideo?: VideoContentCategory[];
  /** 비디오 콘텐츠 지속 시간 설정 */
  videoContentDuration?: {
    /**
     * 비디오 카테고리 아이디
     * @example "63ca10f07ffdef6d162b8628"
     */
    categoryID?: string;
    /**
     * 이행 기간
     * @example 2
     */
    duration?: number;
    /**
     * 주당 수행 횟수
     * @example 3
     */
    doPerWeek?: number;
  }[];
  /**
   * 기본 비디오 콘텐츠 메시지
   * @example "기본 비디오 콘텐츠 메시지입니다."
   */
  defaultVCMessage?: string;
  /**
   * 기본 비디오 콘텐츠 SMS 메시지
   * @example "기본 비디오 콘텐츠 SMS 메시지입니다."
   */
  defaultVCSMSMessage?: string;
  /**
   * 병원 ID
   * @example "65fa84e782a74f66120885da"
   */
  hospitalID?: string;
  /** 첫 번째 선택된 video content hospital id */
  selectedFirstVCH?: string;
  /** 두 번째 선택된 video content hospital id */
  selectedSecondVCH?: string;
  /**
   * 첫 번째 비디오 콘텐츠 사용자 메시지
   * @example "{{고객명}}님, 메디팔정형외과의 홍길동 원장입니다. 허리통증 완화를 위한 코어 운동을 보내드립니다."
   */
  firstVCUMessage?: string;
  /**
   * 두 번째 비디오 콘텐츠 사용자 메시지
   * @example "활기찬 하루의 시작을 위한 5분 스트레칭 보내드립니다. 매일 아침마다 짧은 스트레칭으로 내 몸을 깨워 맑은 컨디션으로 하루를 시작해보세요."
   */
  secondVCUMessage?: string;
  /**
   * 비디오 콘텐츠 발송 시간 간격
   * @format date-time
   * @example "1970-01-01T09:00:00.000+09:00"
   */
  sendVCInterval?: string;
  /**
   * 홈케어 콘텐츠 뱃지 출력을 위한 백분율 순위 기준값
   * @example 30
   */
  vcuBadge?: number;
  /**
   * 삭제 여부
   * @example false
   */
  isRemoved?: boolean;
  /** 사용할 대 카테고리 정보 배열 */
  topVCCategories?: {
    /** 비디오 콘텐츠 카테고리 아이디 */
    categoryID?: string;
    /**
     * 정렬 순서
     * @example 1
     */
    sortNum?: number;
    /**
     * 삭제 여부
     * @example false
     */
    isRemoved?: boolean;
  }[];
  /** 컬러 팔레트 */
  colorPalette?: ColorPalette;
  /**
   * 치료 주의 메시지
   * @example "치료 시 주의사항입니다."
   */
  treatmentCautionMessage?: string;
  /**
   * 이벤트 채팅 메시지
   * @example "이벤트 채팅 메시지입니다."
   */
  eventChatMessage?: string;
  /**
   * 사후 관리 채팅 메시지
   * @example "사후 관리 채팅 메시지입니다."
   */
  aftercareChatMessage?: string;
  /**
   * 사용자 태그 사용 여부
   * @example false
   */
  usingUserTag?: boolean;
  /** 채팅 응답 필요 시간 */
  chatResponseRequiredTime?: {
    /**
     * 요일 인덱스 (0 = 일요일, 6 = 토요일)
     * @example 1
     */
    dayIndex?: number;
    /**
     * 시작 시간
     * @format date-time
     * @example "1970-01-01T09:00:00.000+09:00"
     */
    startedAt?: string;
    /**
     * 종료 시간
     * @format date-time
     * @example "1970-01-01T18:00:00.000+09:00"
     */
    endedAt?: string;
  }[];
  /** 채팅 응답 필요 사용자 */
  chatResponseRequiredUsers?: User[];
  /**
   * 채팅 응답 필요 사용 여부
   * @example false
   */
  usingChatResponseRequired?: boolean;
  /**
   * 기본 상담사 ObjectId
   * @example "5f7b1b3b7f3b9b001f7b1b3b"
   */
  defaultCounselorId: string;
  /** 기본 상담사 ObjectId 배열 */
  defaultCounselorIds?: string[];
  /**
   * 병원에서 생성 가능한 병원 직원 계정 최대 개수
   * @example 1
   */
  maximumCreatableAccountCount?: number;
  /**
   * 병원 별 직원 계정 개수 조정 요청 일시
   * @format date-time
   * @example "2020-01-01T00:00:00.000Z"
   */
  accountCountTuningRequestedAt?: string;
  /**
   * 조정 요청된 병원 직원 계정 개수
   * @example 5
   */
  requestedAccountCount?: number;
  /**
   * 병원 별 직원 계정 개수 조정 요청자 ID
   * @example "5f7b1b3b7f3b9b001f7b1b3b"
   */
  accountCountTuningRequesterID?: string;
  /**
   * 병원 별 직원 계정 개수 최종 조정 일시
   * @format date-time
   * @example "2020-01-01T00:00:00.000Z"
   */
  finalAccountCountTunedAt?: string;
  /**
   * 병원 별 직원 계정 개수 최종 조정자 ID
   * @example "5f7b1b3b7f3b9b001f7b1b3b"
   */
  finalAccountCountTunerID?: string;
  /**
   * 병원 직원 계정 수 변경 사유
   * @example "병원 직원 계정 수 변경 사유입니다."
   */
  tuningReason?: string;
  /**
   * 카카오 알림톡 및 카카오 친구톡 연동 여부 - 메디팔 직원이 어드민에서 설정한 값
   * @example false
   */
  usingKakaoAlimAndFriendTalkLinkage: boolean;
  /**
   * 카카오 알림톡 및 카카오 친구톡 연동 여부
   * @example false
   */
  hasKakaoAlimAndFriendTalkLinkage: boolean;
  /**
   * 카카오 알림톡 및 카카오 친구톡 연동 일시
   * @format date-time
   * @example "2024-01-01T00:00:00.000Z"
   */
  kakaoAlimAndFriendTalkLinkedAt?: string;
  /**
   * 카카오 알림톡 및 카카오 친구톡 연동 해제 일시
   * @format date-time
   * @example "2024-01-01T00:00:00.000Z"
   */
  kakaoAlimAndFriendTalkUnlinkedAt?: string;
  /**
   * 카카오 알림톡 및 카카오 친구톡 연동 준비 상태
   * @example false
   */
  isReadyForKakaoAlimAndFriendTalkLinkage?: boolean;
  /**
   * 카카오 알림톡 및 카카오 친구톡 연동 준비 일시
   * @format date-time
   * @example "2024-01-01T00:00:00.000Z"
   */
  kakaoAlimAndFriendTalkReadyAt?: string;
  /**
   * 카카오 알림톡 및 카카오 친구톡 연동 준비 당시 카카오 발신 프로필 키
   * @example "KAKAO_PROFILE_SENDER_KEY"
   */
  kakaoProfileSenderKeyAtReady?: string;
  /** 카카오 알림톡 국내 가입문자용 커스텀 템플릿코드 */
  registAlimTalkTemplateCodeForKorean?: string;
  /** 카카오 알림톡 국내 가입문자용 커스텀 템플릿 이름 */
  registAlimTalkTemplateNameForKorean?: string;
  /** 카카오 알림톡 국내 가입문자용 커스텀 템플릿 내용. 버튼이 있을 경우 버튼까지 포함된 문자열 JSON 객체 내용 */
  registAlimTalkContentForKorean?: string;
  /**
   * 카카오 상담톡 연동 여부
   * @example false
   */
  hasKakaoConsultationTalkLinkage: boolean;
  /**
   * 카카오 상담톡 연동 일시
   * @format date-time
   * @example "2024-01-01T00:00:00.000Z"
   */
  kakaoConsultationTalkLinkedAt?: string;
  /**
   * 카카오 상담톡 연동 해제 일시
   * @format date-time
   * @example "2024-01-01T00:00:00.000Z"
   */
  kakaoConsultationTalkUnlinkedAt?: string;
  /**
   * 인스타그램 연동 여부
   * @example false
   */
  hasInstagramLinkage: boolean;
  /**
   * 인스타그램 연동 요청 여부 - 병원 직원이 일렉트론에서 요청했지만 메디팔 직원이 아직 허용하지 않은 경우
   * @example false
   */
  hasInstagramLinkageRequest: boolean;
  /**
   * 인스타그램 연동 일시
   * @format date-time
   * @example "2024-01-01T00:00:00.000Z"
   */
  instagramLinkedAt?: string;
  /**
   * 인스타그램 연동 해제 일시
   * @format date-time
   * @example "2024-01-01T00:00:00.000Z"
   */
  instagramUnlinkedAt?: string;
  /**
   * 인스타그램 연동 최대 계정 개수
   * @example 1
   */
  maximumInstagramAccountCount?: number;
  /**
   * 톡톡 연동 여부
   * @example false
   */
  hasTalkTalkLinkage: boolean;
  /**
   * 톡톡 연동 일시
   * @format date-time
   * @example "2024-01-01T00:00:00.000Z"
   */
  talkTalkLinkedAt?: string;
  /**
   * 톡톡 연동 해제 일시
   * @format date-time
   * @example "2024-01-01T00:00:00.000Z"
   */
  talkTalkUnlinkedAt?: string;
  /**
   * 톡톡 연동 최대 계정 개수
   * @example 1
   */
  maximumTalkTalkAccountCount?: number;
  /**
   * 라인 연동 여부
   * @example false
   */
  hasLineLinkage: boolean;
  /**
   * 라인 연동 일시
   * @format date-time
   * @example "2024-01-01T00:00:00.000Z"
   */
  lineLinkedAt?: string;
  /**
   * 라인 연동 해제 일시
   * @format date-time
   * @example "2024-01-01T00:00:00.000Z"
   */
  lineUnlinkedAt?: string;
  /**
   * 라인 연동 최대 계정 개수
   * @example 1
   */
  maximumLineAccountCount?: number;
  /**
   * 위챗 연동 여부
   * @example false
   */
  hasWechatLinkage: boolean;
  /**
   * 위챗 연동 최대 계정 개수
   * @example 1
   */
  maximumWechatAccountCount?: number;
  /**
   * 위챗 연동 일시
   * @format date-time
   * @example "2024-01-01T00:00:00.000Z"
   */
  wechatLinkedAt?: string;
  /**
   * 위챗 연동 해제 일시
   * @format date-time
   * @example "2024-01-01T00:00:00.000Z"
   */
  wechatUnlinkedAt?: string;
  /**
   * 왓츠앱 연동 여부
   * @example false
   */
  hasWhatsappLinkage: boolean;
  /**
   * 왓츠앱 연동 일시
   * @format date-time
   * @example "2024-01-01T00:00:00.000Z"
   */
  whatsappLinkedAt?: string;
  /**
   * 왓츠앱 연동 해제 일시
   * @format date-time
   * @example "2024-01-01T00:00:00.000Z"
   */
  whatsappUnlinkedAt?: string;
  /**
   * 왓츠앱 연동 최대 계정 개수
   * @example 1
   */
  maximumWhatsappAccountCount?: number;
  /**
   * 카카오 브랜드메시지 연동 여부
   * @example false
   */
  hasKakaoBrandMessageLinkage: boolean;
  /**
   * 세종병원 연동 여부
   * @example false
   */
  hasSejongHospitalLinkage: boolean;
  /**
   * 세종병원 연동 일시
   * @format date-time
   * @example "2024-01-01T00:00:00.000Z"
   */
  sejongHospitalLinkedAt?: string;
  /**
   * 세종병원 연동 해제 일시
   * @format date-time
   * @example "2024-01-01T00:00:00.000Z"
   */
  sejongHospitalUnlinkedAt?: string;
  /**
   * 세종병원 관련 자동화 중단 여부
   * @example false
   */
  hasStoppedAutomationForSejongHospital: boolean;
  /**
   * 세종병원 관련 자동화 중단 일시
   * @format date-time
   * @example "2024-01-01T00:00:00.000Z"
   */
  latestStoppedAutomationDateTime?: string;
  /**
   * 세종병원 기관 코드
   * @example "201"
   */
  sejongHospitalOrganizationCode?: string;
  /**
   * 메시지 전송 차단 사용 여부
   * @example false
   */
  usingBlockingSendingMessage: boolean;
  /**
   * 고객 등록 시 가입문자 자동 발송 사용 여부 (기본값 사용)
   * @example true
   */
  usingRegisterSMSSend?: boolean;
  /**
   * 광고성 문자 수신 여부에 대한 체크박스 표시 사용 여부 (기본값 미사용)
   * @example false
   */
  usingAdSMSConsent?: boolean;
  /**
   * 생성 날짜
   * @format date-time
   * @example "2020-01-01T00:00:00.000Z"
   */
  createdAt?: string;
  /**
   * 업데이트 날짜
   * @format date-time
   * @example "2020-01-02T00:00:00.000Z"
   */
  updatedAt?: string;
}

export interface TreatmentCategoryWithTreatmentCaution {
  /** 치료 태그 아이디 */
  _id: string;
  /** 고객유형(치료유형) 명칭 */
  categoryName: string;
  /** 병원ID */
  hospitalID: string;
  /**
   * 정렬순서
   * @default 9999
   */
  sortNum?: number;
  /** Colorpalette 모델의 basicPalette 인덱스 */
  paletteIndex?: number;
  /** 치료시 주의사항 treatmentCaution */
  treatmentCautionID: TreatmentCaution;
  /**
   * 삭제 여부를 나타내는 플래그
   * @default false
   */
  isRemoved?: boolean;
  /** 커스텀 색상 사용 여부 - true일 경우 customColor 필드 필수 */
  isUsingCustomColor?: boolean;
  /**
   * 커스텀 색상 코드 - isUsingCustomColor가 true 가 아닌데 값이 들어있으면 오류 발생
   * @example "#FFFFFF"
   */
  customColor?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface TreatmentCaution {
  /** 치료 주의사항 아이디 */
  _id: string;
  /** 해당 유의사항을 사용하는 병원의 ID */
  hospitalID: string;
  /** 치료유형 선택시 채팅으로 전달될 이미지 파일ID 목록 */
  fileIDs?: string[];
  /** 내용을 최초 작성한 사용자의 ID */
  writerID: string;
  /** 마지막으로 수정한 사용자의 ID */
  modifierID?: string;
  /** 삭제 여부 플래그 */
  isRemoved?: boolean;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface VideoContentCategory {
  /** 홈케어 콘텐츠 카테고리 고유ID */
  _id?: string;
  /** 운동콘텐츠 카테고리명 */
  categoryName?: string;
  /** 병원ID */
  hospitalID?: string;
  /** 정렬순서 */
  sortNum?: number;
  /** 상위 카테고리 ID. */
  parentCategoryIDs?: string[];
  /** 카테고리 대 여부 */
  isTop?: boolean;
  /** 카테고리 중 여부 */
  isParent?: boolean;
  /** 숨김 처리 여부 */
  isHidden?: boolean;
  /** 카테고리별 기초 콘텐츠 여부 */
  isBasic?: boolean;
  /** 운동콘텐츠 카테고리에 대한 설명 (oo의원 전용 콘텐츠 등) */
  description?: string;
  /** 카테고리의 명칭 (부위, 난이도, ...) */
  typeName?: string;
  /** 컨디셔닝 영상 여부 */
  isConditioning?: boolean;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface ColorPalette {
  /**
   * 기본 팔레트 여부
   * @example false
   */
  isDefault?: boolean;
  /**
   * 병원 ID
   * @example "507f1f77bcf86cd799439011"
   */
  hospitalID?: string;
  /**
   * 기본 색상 팔레트
   * @example ["#FFFFFF","#000000"]
   */
  basicPalette?: string[];
  /**
   * 사용자 정의 색상 팔레트
   * @example ["#FF5733","#33D4FF"]
   */
  customPalette?: string[];
  /**
   * 생성 날짜
   * @format date-time
   * @example "2020-01-01T00:00:00.000Z"
   */
  createdAt?: string;
  /**
   * 업데이트 날짜
   * @format date-time
   * @example "2020-01-02T00:00:00.000Z"
   */
  updatedAt?: string;
}

export interface User {
  /** 전화번호 문자열 */
  phone?: string;
  /** 유저의 타입. */
  type?: number;
  /** 로그인 시 사용되는 id */
  id?: string;
  /** 실 이름 */
  realName?: string;
  /** 유저가 보는 이름 */
  name?: string;
  /** 생년 월 일 */
  birth?: string;
  /** 사용자의 성별. */
  gender?: string;
  /** 사용자의 나이 */
  age?: string;
  visit?: string;
  /** 사용자의 상태 */
  status?: string;
  /** 프로필 이미지로 사용될 파일의 ID */
  photo?: string;
  /** 마지막으로 저장된 fcm token 값 */
  fcmToken?: string;
  /** 등록된 모든 fcm token 배열 */
  deviceTokens?: any[];
  /** fcm token 값을 키로 한 디바이스 정보 */
  deviceInfos?: Record<string, any>;
  /** 마지막으로 저장된 사용자의 OS 정보 */
  d_OS?: string;
  /** 마지막으로 저장된 OS 버전 정보 */
  d_OS_Version?: string;
  /** 마지막으로 저장된 App 버전 정보 */
  d_App_Version?: string;
  /** 마지막으로 저장된 디바이스의 이름 */
  d_Name?: string;
  /** 사용자가 진행중인 HService ID 배열 */
  hservices?: any[];
  /** 사용자가 속해 있는 병원 ID 배열 */
  hospitalID?: any[];
  /** 계정의 초기화 진행 여부 플래그 */
  needInitial?: boolean;
  /** 매니저 유저의 경우  소개글 */
  introduction?: string;
  /** 매니저 계정의 경우  경력. */
  career?: string;
  isAfterDoc?: boolean;
  /** 계정의 탈퇴 여부 플래그 */
  isLeave?: boolean;
  /** 마지막으로 로그인한 일시 */
  lastLogin?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막으로 수정된 일시 */
  updatedAt?: string;
  /** 환자의 경우  가입 일시. (가장 최근 가입한 HService 기준 갱신) */
  joinedAt?: string;
  /** 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값. */
  isDoctor?: boolean;
  /** 예약만 등록 유저 여부 */
  isUnregisteredUser?: boolean;
  /** 환자의 경우  가입하게된 Short URL 경로 */
  joinPath?: string;
  /** 환자의 경우  가입 시 방문한 경유페이지(layover) */
  layoverType?: string;
  /** 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_terms?: string;
  /** 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_privacy?: string;
  /** 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_sensitive?: string;
  /** 병원 계정의 경우  환자 등록 가능 여부 플래그 */
  auth_regist_user?: boolean;
  /** 권한 설정 ID */
  authorizationTypeID?: AuthorizationType;
  /** 병원내 계정의 직/직책 */
  jobType?: string;
  /** 대시보드 접근권한 */
  canReadDashboard?: boolean;
}

export interface AuthorizationType {
  /** 권한타입 객체 오브젝트 아이디 */
  _id: string;
  /**
   * 샘플 데이터 구분
   * @default false
   */
  isSample?: boolean;
  /** 권한타입이 속한 병원 아이디 */
  hospitalID: string;
  /** 권한타입의 이름. 마스터, 관리자, 일반 중 하나 */
  name?: string;
  /** 환자 채팅 관리 권한 */
  canControlPatientChatting?: boolean;
  /** 환자 서비스 차단 권한 */
  canBanPatientToService?: boolean;
  /** 자동화 설정 권한 */
  canUpsertAutomation?: boolean;
  /** 자동화 삭제 권한 */
  canDeleteAutomation?: boolean;
  /** 자동화 대시보드 조회 권한 */
  canReadAutomationDashboard?: boolean;
  /** 콘텐츠 수정 권한 */
  canUpsertContent?: boolean;
  /** 콘텐츠 삭제 권한 */
  canDeleteContent?: boolean;
  /** 메뉴얼 폴더 및 태그 설정 권한 */
  canControlManualFolderAndTagStatus?: boolean;
  /** 메뉴얼 생성 권한 */
  canCreateManual?: boolean;
  /** 병원 정보 조회 권한 */
  canAccessHospitalInformation?: boolean;
  /** 서비스 정보 조회 권한 */
  canAccessHospitalService?: boolean;
  /** 계정 정보 조회 권한 */
  canAccessHospitalAccount?: boolean;
  /** 결제 관리 접근 권한 */
  canAccessPaymentManagement?: boolean;
  /** 결제 권한 */
  canCreatePayment?: boolean;
  /** 서비스 정보 수정 권한 */
  canModifyService?: boolean;
  /** 서비스 종료 권한 */
  canSuspendService?: boolean;
  /** 예약설정 수정 권한 */
  canManageReservation?: boolean;
  /** 예약설정 스케줄 수정 권한 */
  canManageSchedule?: boolean;
  /** 병원정보 수정 권한 */
  canUpdateHospital?: boolean;
  /** 환자 정보 다운로드 권한 */
  canDownloadPatientData?: boolean;
  /** 재진 마케팅 등록/수정 */
  canUpsertMarketingAutomation?: boolean;
  /** 재진 마케팅 삭제 */
  canDeleteMarketingAutomation?: boolean;
  /** 대시보드 조회 여부 */
  canReadMarketingAutomationDashboard?: boolean;
  /** 결제 정보 조회 여부 */
  canReadPaymentRecords?: boolean;
  /** 재진마케팅 전송 기록 엑셀 다운로드 권한 */
  canDownloadMarketingHistory?: boolean;
  /** 상담자동화 발송 기록 엑셀 다운로드 권한 */
  canDownloadConsultationHistory?: boolean;
  /** 메디팔 AI 사용현황 조회 권한 */
  canReadMedipalAIUsage?: boolean;
  /** 메디팔 AI 업무 조정 권한 */
  canAdjustMedipalAITask?: boolean;
  /** 메디팔 AI 예약 조회 권한 */
  canReadMedipalAIReservation?: boolean;
  /** 메디팔 AI 콜 조회 권한 */
  canReadMedipalAICall?: boolean;
  /** 메디팔 AI 콜 최고 권한 */
  canControlMedipalAICall?: boolean;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface ServiceSettingSimple {
  /**
   * 서비스 설정 아이디
   * @example "63d7bafc1374672f7c407f00"
   */
  _id: string;
  /**
   * 샘플 여부
   * @example false
   */
  isSample?: boolean;
  /**
   * 서비스 설정 이름
   * @example "기본 서비스 설정"
   */
  name?: string;
  /** 치료 카테고리 목록 */
  treatmentCategories?: string[];
  /**
   * 첫 방문 및 시작 날짜 사용 여부
   * @example false
   */
  usingFirstVisitStartDate?: boolean;
  /**
   * 자동화 정책 SINGLE, MULTIPLE
   * @example "MULTIPLE"
   */
  automationPolicy?: "SINGLE" | "MULTIPLE";
  /**
   * 차트 번호 사용 여부
   * @example false
   */
  usingChartNumber?: boolean;
  /**
   * 국가 코드 사용 여부
   * @example false
   */
  usingCountryCode?: boolean;
  /** 생일 사용 여부 */
  usingBirthDay?: boolean;
  /** 성별 사용 여부 */
  usingGender?: boolean;
  /** 치료 태그 사용 여부 */
  usingTreatmentTag?: boolean;
  /** 국적 사용 여부 */
  usingNationality?: boolean;
  /**
   * 비디오 자동 전송 여부
   * @example false
   */
  autoSendVideo?: boolean;
  /** 자동 전송 비디오 사용 여부 */
  usingAutoSendVideo?: string[];
  /** 비디오 콘텐츠 지속 시간 설정 */
  videoContentDuration?: {
    /** 대분류 카테고리 ObjectId */
    categoryID?: string;
    /**
     * 이행 기간
     * @example 2
     */
    duration?: number;
    /**
     * 주당 수행 횟수
     * @example 3
     */
    doPerWeek?: number;
  }[];
  /**
   * 기본 비디오 콘텐츠 메시지
   * @example "기본 비디오 콘텐츠 메시지입니다."
   */
  defaultVCMessage?: string;
  /**
   * 기본 비디오 콘텐츠 SMS 메시지
   * @example "기본 비디오 콘텐츠 SMS 메시지입니다."
   */
  defaultVCSMSMessage?: string;
  /** 병원 ObjectId */
  hospitalID: string;
  /** 첫 번째 선택된 비디오 콘텐츠 병원 ObjectId */
  selectedFirstVCH?: string;
  /** 두 번째 선택된 비디오 콘텐츠 병원 ObjectId */
  selectedSecondVCH?: string;
  /**
   * 첫 번째 비디오 콘텐츠 업데이트 메시지
   * @example "첫 번째 비디오 콘텐츠 업데이트 메시지입니다."
   */
  firstVCUMessage?: string;
  /**
   * 두 번째 비디오 콘텐츠 업데이트 메시지
   * @example "두 번째 비디오 콘텐츠 업데이트 메시지입니다."
   */
  secondVCUMessage?: string;
  /**
   * 두 번째 콘텐츠 발송 시간 간격
   * @format date-time
   * @example "1970-01-01T09:00:00.000+09:00"
   */
  sendVCInterval?: string;
  /**
   * 홈케어 콘텐츠 뱃지 출력을 위한 백분율 순위 기준값
   * @example 30
   */
  vcuBadge?: number;
  /**
   * 삭제 여부
   * @example false
   */
  isRemoved?: boolean;
  /** 사용할 대 카테고리 정보 배열 */
  topVCCategories?: {
    /** 대분류 카테고리 ObjectId */
    categoryID?: string;
    /**
     * 삭제 여부
     * @example false
     */
    isRemoved?: boolean;
  }[];
  /** 컬러 팔레트 ObjectId */
  colorPalette?: string;
  /**
   * 치료 주의 메시지
   * @example "치료 시 주의사항입니다."
   */
  treatmentCautionMessage?: string;
  /**
   * 이벤트 채팅 메시지
   * @example "이벤트 채팅 메시지입니다."
   */
  eventChatMessage?: string;
  /**
   * 사후 관리 채팅 메시지
   * @example "사후 관리 채팅 메시지입니다."
   */
  aftercareChatMessage?: string;
  /**
   * 사용자 태그 사용 여부
   * @example false
   */
  usingUserTag?: boolean;
  /** 채팅 응답 필요 시간 */
  chatResponseRequiredTime?: {
    /**
     * 요일 인덱스 (0 = 일요일, 6 = 토요일)
     * @example 1
     */
    dayIndex?: number;
    /**
     * 시작 시간
     * @format date-time
     * @example "1970-01-01T09:00:00.000+09:00"
     */
    startedAt?: string;
    /**
     * 종료 시간
     * @format date-time
     * @example "1970-01-01T18:00:00.000+09:00"
     */
    endedAt?: string;
  }[];
  /** 채팅 응답 필요 사용자 */
  chatResponseRequiredUsers?: string[];
  /**
   * 채팅 응답 필요 사용 여부
   * @example false
   */
  usingChatResponseRequired?: boolean;
  /**
   * 기본 상담사 ObjectId
   * @example "5f7b1b3b7f3b9b001f7b1b3b"
   */
  defaultCounselorId?: string;
  /** 기본 상담사 ObjectId 배열 */
  defaultCounselorIds?: string[];
  /**
   * 병원에서 생성 가능한 병원 직원 계정 최대 개수
   * @example 1
   */
  maximumCreatableAccountCount?: number;
  /**
   * 병원 별 직원 계정 개수 조정 요청 일시
   * @format date-time
   * @example "2020-01-01T00:00:00.000Z"
   */
  accountCountTuningRequestedAt?: string;
  /**
   * 조정 요청된 병원 직원 계정 개수
   * @example 5
   */
  requestedAccountCount?: number;
  /**
   * 병원 별 직원 계정 개수 조정 요청자 ID
   * @example "5f7b1b3b7f3b9b001f7b1b3b"
   */
  accountCountTuningRequesterID?: string;
  /**
   * 병원 별 직원 계정 개수 최종 조정 일시
   * @format date-time
   * @example "2020-01-01T00:00:00.000Z"
   */
  finalAccountCountTunedAt?: string;
  /**
   * 병원 별 직원 계정 개수 최종 조정자 ID
   * @example "5f7b1b3b7f3b9b001f7b1b3b"
   */
  finalAccountCountTunerID?: string;
  /**
   * 고객 등록 시 가입문자 자동 발송 사용 여부 (기본값 사용)
   * @example true
   */
  usingRegisterSMSSend?: boolean;
  /**
   * 광고성 문자 수신 여부에 대한 체크박스 표시 사용 여부 (기본값 미사용)
   * @example false
   */
  usingAdSMSConsent?: boolean;
  /**
   * 생성 날짜
   * @format date-time
   * @example "2020-01-01T00:00:00.000Z"
   */
  createdAt?: string;
  /**
   * 업데이트 날짜
   * @format date-time
   * @example "2020-01-02T00:00:00.000Z"
   */
  updatedAt?: string;
}

export interface KaKaoControllerFindLinkageInfoResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    requesterID: string;
    requesterName: string;
    requesterContact: string;
    maxCount: number;
    isRequested: boolean;
    isRequestApproved: boolean;
    linkages: {
      _id: string;
      channelID: string;
      channelName: string;
      adminPhoneNumber: string;
      category: string[];
      brandMessage?: {
        status: "NOT_APPROVED" | "IN_REQUEST" | "APPROVED";
        marketingAgreementUrl?: string;
      };
    }[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KaKaoControllerRequestSetupBodyRequest {
  /**
   * 신청자의 이름
   * @example "홍길동"
   */
  name: string;
  /**
   * 신청자의 전화번호
   * @example "010-1234-5678"
   */
  phone: string;
}

export interface KaKaoControllerRequestSetupResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data?: Record<string, any>;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface WechatControllerFindLinkageInfoResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    requesterID: string;
    requesterName: string;
    requesterContact: string;
    maxCount: number;
    isRequested: boolean;
    isRequestApproved: boolean;
    linkages: {
      _id: string;
      channelID: string;
      channelName: string;
      appID: string;
    }[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface WechatControllerUnlinkLinkageResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data?: Record<string, any>;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface WechatControllerHandleBodyRequest {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
  /**
   * 신청자의 이름
   * @example "홍길동"
   */
  name: string;
  /**
   * 신청자의 전화번호
   * @example "010-1234-5678"
   */
  phone: string;
}

export interface WechatControllerHandleResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data?: Record<string, any>;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface WhatsappControllerFindLinkageInfoResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    requesterID: string;
    requesterName: string;
    requesterContact: string;
    maxCount: number;
    isRequested: boolean;
    isRequestApproved: boolean;
    linkages: {
      _id: string;
      channelID: string;
      channelName: string;
      displayPhoneNumber: string;
      wabaID: string;
      wabaName?: string;
      error?: {
        code?: number;
        message?: string;
      };
    }[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface WhatsappControllerUnlinkLinkageResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data?: Record<string, any>;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface WhatsappControllerHandleBodyRequest {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
  /**
   * 신청자의 이름
   * @example "홍길동"
   */
  name: string;
  /**
   * 신청자의 전화번호
   * @example "010-1234-5678"
   */
  phone: string;
}

export interface WhatsappControllerHandleResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data?: Record<string, any>;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface InstagramControllerUpdateInstagramAccountStatusResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  /** @example {"isProcessing":true} */
  data: {
    /** @default true */
    isProcessing: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface InstagramControllerFindInstagramAccountsResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 인스타그램 연동 요청자 ID
     * @example "63d7bafc1374672f7c407efd"
     */
    requesterID?: string;
    /**
     * 인스타그램 연동 요청자 이름
     * @example "홍길동"
     */
    requesterName?: string;
    /**
     * 인스타그램 연동 요청자 연락처
     * @example "010-1234-5678"
     */
    requesterContact?: string;
    /**
     * 최대 인스타그램 연동 가능 계정 수
     * @example 3
     */
    maximumInstagramAccountCount: number;
    /**
     * 가장 마지막으로 인스타그램 연동 요청한 일시
     * @format date
     * @example "2025-01-01T00:00:00.000Z"
     */
    latestLinkageRequestDateTime?: string;
    /**
     * 인스타그램 연동 요청 여부
     * @example true
     */
    isRequested: boolean;
    /**
     * 인스타그램 연동 요청 승인 여부
     * @example true
     */
    isRequestApproved: boolean;
    /** 인스타그램 연동 계정 정보 목록 */
    instagramAccounts?: {
      /**
       * 인스타그램 로그인 ID
       * @example "@afterdoc.medipal"
       */
      userName: string;
      /**
       * 인스타그램 사용자 이름
       * @example "홍길동"
       */
      fullName?: string;
      /**
       * 인스타그램 계정 타입 - BUSINESS / Media_Creator
       * @example "BUSINESS"
       */
      accountType?: string;
      /**
       * 재연동 사유 유형
       * @example "EXPIRED_AUTHORIZATION_CODE"
       */
      reAuthorizationType?:
        | "EXPIRED_AUTHORIZATION_CODE"
        | "PASSWORD_CHANGED"
        | "REMOVED_AUTHORIZATION"
        | "DISCONNECTED_ACCOUNT"
        | "REAUTHORIZATION_REQUIRED";
      /**
       * 재연동 사유
       * @example "인증 코드 만료"
       */
      reAuthorizationReason?: string;
      /**
       * 인증 만료 잔여 일 수 - 최대 60일
       * @example 3
       */
      authorizationRemainingDays?: number;
    }[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface InstagramAccountsHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 인스타그램 연동 요청자 ID
     * @example "63d7bafc1374672f7c407efd"
     */
    requesterID?: string;
    /**
     * 인스타그램 연동 요청자 이름
     * @example "홍길동"
     */
    requesterName?: string;
    /**
     * 인스타그램 연동 요청자 연락처
     * @example "010-1234-5678"
     */
    requesterContact?: string;
    /**
     * 최대 인스타그램 연동 가능 계정 수
     * @example 3
     */
    maximumInstagramAccountCount: number;
    /**
     * 가장 마지막으로 인스타그램 연동 요청한 일시
     * @format date
     * @example "2025-01-01T00:00:00.000Z"
     */
    latestLinkageRequestDateTime?: string;
    /**
     * 인스타그램 연동 요청 여부
     * @example true
     */
    isRequested: boolean;
    /**
     * 인스타그램 연동 요청 승인 여부
     * @example true
     */
    isRequestApproved: boolean;
    /** 인스타그램 연동 계정 정보 목록 */
    instagramAccounts?: {
      /**
       * 인스타그램 로그인 ID
       * @example "@afterdoc.medipal"
       */
      userName: string;
      /**
       * 인스타그램 사용자 이름
       * @example "홍길동"
       */
      fullName?: string;
      /**
       * 인스타그램 계정 타입 - BUSINESS / Media_Creator
       * @example "BUSINESS"
       */
      accountType?: string;
      /**
       * 재연동 사유 유형 - 로그인 만료, 비밀번호 변경, 권한 삭제, 유실된 계정, 재인가 필요
       * @example "EXPIRED_AUTHORIZATION_CODE"
       */
      reAuthorizationType?:
        | "EXPIRED_AUTHORIZATION_CODE"
        | "PASSWORD_CHANGED"
        | "REMOVED_AUTHORIZATION"
        | "DISCONNECTED_ACCOUNT"
        | "REAUTHORIZATION_REQUIRED";
      /**
       * 재연동 사유
       * @example "인증 코드 만료"
       */
      reAuthorizationReason?: string;
      /**
       * 인증 만료 잔여 일 수 - 최대 60일
       * @example 3
       */
      authorizationRemainingDays?: number;
    }[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoLatestLinkageHistoryHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 카카오 연동 요청자 ID
     * @example "63d7bafc1374672f7c407efd"
     */
    requesterID: string;
    /**
     * 카카오 연동 요청자 이름
     * @example "홍길동"
     */
    requesterName: string;
    /**
     * 카카오 연동 요청자 연락처
     * @example "010-1234-5678"
     */
    requesterContact?: string;
    /**
     * 병원 전화번호
     * @example "010-1234-5678"
     */
    hospitalPhone?: string;
    /**
     * 연동 시작 희망 일시
     * @format date
     * @example "2025-01-01T00:00:00.000Z"
     */
    toBeStartedAt?: string;
    /**
     * 검색 가능한 카카오 채널 ID
     * @example "123456"
     */
    searchableChannelId?: string;
    /**
     * 카카오 채널 관리자 전화번호
     * @example "010-1234-5678"
     */
    channelAdminPhone?: string;
    /**
     * 알림톡 및 친구톡 연동 시 필요한 인증번호
     * @example "123456"
     */
    authenticationNumber?: string;
    /**
     * 카카오에 등록된 고객센터 연락처
     * @example "010-1234-5678"
     */
    customerCenterContact?: string;
    /** 카카오 채널 카테고리 정보 */
    categoryInformation?: {
      /**
       * 카카오 채널 대분류
       * @example "의료"
       */
      broadCategory: string;
      /**
       * 카카오 채널 중분류
       * @example "병원"
       */
      mediumCategory: string;
      /**
       * 카카오 채널 소분류
       * @example "종합병원"
       */
      smallCategory: string;
    };
    /** 상담 정보 */
    consultationInformation?: {
      /**
       * 상담 시작 시간
       * @format date
       */
      consultationStartTime: string;
      /**
       * 상담 종료 시간
       * @format date
       */
      consultationEndTime: string;
      /**
       * 일요일 상담 가능 여부
       * @example true
       */
      sundayAvailable?: boolean;
      /**
       * 월요일 상담 가능 여부
       * @example true
       */
      mondayAvailable?: boolean;
      /**
       * 화요일 상담 가능 여부
       * @example true
       */
      tuesdayAvailable?: boolean;
      /**
       * 수요일 상담 가능 여부
       * @example true
       */
      wednesdayAvailable?: boolean;
      /**
       * 목요일 상담 가능 여부
       * @example true
       */
      thursdayAvailable?: boolean;
      /**
       * 금요일 상담 가능 여부
       * @example true
       */
      fridayAvailable?: boolean;
      /**
       * 토요일 상담 가능 여부
       * @example true
       */
      saturdayAvailable?: boolean;
    };
    /**
     * 상담 가능 요일 및 시간 정보
     * @example [{"dayIndex":1,"startedAt":"2025-01-01T09:00:00.000+0900","endedAt":"2025-01-01T18:00:00.000+0900"}]
     */
    careSchedule?:
      | {
          /**
           * 요일 인덱스
           * @example 0
           */
          dayIndex: number;
          /**
           * 상담 시작 시간
           * @format date
           * @example "2025-01-01T09:00:00.000+0900"
           */
          startedAt: string;
          /**
           * 상담 종료 시간
           * @format date
           * @example "2025-01-01T18:00:00.000+0900"
           */
          endedAt: string;
        }[]
      | null;
    isActivate?: boolean;
    /** @format date */
    activatedAt?: string;
    /** @format date */
    deactivatedAt?: string;
    modifierID?: string;
    /**
     * 카카오 연동 요청 일시
     * @format date
     * @example "2025-01-01T00:00:00.000Z"
     */
    createdAt: string;
    /**
     * 카카오 연동 정보 수정 일시
     * @format date
     * @example "2025-01-01T00:00:00.000Z"
     */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoProfileCategoryHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 카카오 채널 대분류 이름
     * @example "건강"
     */
    broadCategoryName: string;
    subCategory: {
      /**
       * 카카오 채널 중분류 이름
       * @example "병원"
       */
      mediumCategoryName: string;
      smallCategory: {
        /**
         * 카카오 채널 소분류 이름
         * @example "종합병원"
         */
        smallCategoryName: string;
        /**
         * 최종 카카오 채널 코드
         * @example "00100010001"
         */
        code: string;
      }[];
    }[];
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface InstagramAccountLinkageHandlerBodyRequest {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
  /**
   * 인증 코드
   * @example "AQDp6nl1bERAv-"
   */
  authorizationCode: string;
  /**
   * 리다이렉트 URI
   * @example "https://dev.frontend.afterdoc.net/taesung-test"
   */
  redirectUri: string;
}

export interface InstagramAccountLinkageHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 연동 요청 성공 여부 */
    isLinkedSuccess: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface InstagramDisconnectionHandlerBodyRequest {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
  /**
   * 인스타그램 로그인 ID
   * @example "@afterdoc.medipal"
   */
  userName: string;
}

export interface InstagramDisconnectionHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 인스타그램 연동 해제 성공 여부
     * @example true
     */
    isDisconnectedSuccess: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface InstagramLinkageHandlerBodyRequest {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
  /**
   * 신청자 이름
   * @example "홍길동"
   */
  requesterName: string;
  /**
   * 연락 받을 전화번호
   * @example "010-1234-5678"
   */
  toBeContactedPhone: string;
}

export interface InstagramLinkageHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 연동 요청 성공 여부 */
    isLinkedSuccess: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoAlimFriendTalkLinkageHandlerBodyRequest {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
  /**
   * 신청자 이름
   * @example "홍길동"
   */
  requesterName: string;
  /**
   * 연락 받을 전화번호
   * @example "010-1234-5678"
   */
  toBeContactedPhone: string;
  /**
   * 연동 시작 희망 일시
   * @format date
   * @example "2025-01-01T00:00:00.000Z"
   */
  toBeStartedAt: string;
  /**
   * 검색 가능한 카카오 채널 ID
   * @example "123456"
   */
  searchableChannelId: string;
  /**
   * 채널 관리자 전화번호
   * @example "010-1234-5678"
   */
  channelAdminPhone: string;
  /**
   * 인증번호
   * @example "123456"
   */
  authenticationNumber: string;
  /**
   * 카테고리 코드
   * @example "00100010001"
   */
  categoryCode: string;
}

export interface KakaoAlimFriendTalkLinkageHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 연동 요청 성공 여부 */
    isLinkedSuccess: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoAuthenticationNumberHandlerBodyRequest {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
  /**
   * 검색 가능한 카카오 채널 ID
   * @example "123456"
   */
  searchableChannelId: string;
  /**
   * 채널 관리자 전화번호
   * @example "010-1234-5678"
   */
  channelAdminPhoneNumber?: string;
}

export interface KakaoAuthenticationNumberHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 카카오 인증번호 요청 성공 여부
     * @example true
     */
    isAccurateKakaoAuthRequest: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface KakaoConsultationTalkLinkageHandlerBodyRequest {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
  /**
   * 신청자 이름
   * @example "홍길동"
   */
  requesterName: string;
  /**
   * 연락 받을 전화번호
   * @example "010-1234-5678"
   */
  toBeContactedPhone: string;
  /**
   * 연동 시작 희망 일시
   * @format date
   * @example "2025-01-01T00:00:00.000Z"
   */
  toBeStartedAt: string;
  /**
   * 검색 가능한 카카오 채널 ID
   * @example "123456"
   */
  searchableChannelId: string;
  /** 상담 정보 */
  consultationInformation?: {
    /**
     * 상담 시작 시간
     * @format date
     */
    consultationStartTime: string;
    /**
     * 상담 종료 시간
     * @format date
     */
    consultationEndTime: string;
    /**
     * 일요일 상담 가능 여부
     * @example true
     */
    sundayAvailable: boolean;
    /**
     * 월요일 상담 가능 여부
     * @example true
     */
    mondayAvailable: boolean;
    /**
     * 화요일 상담 가능 여부
     * @example true
     */
    tuesdayAvailable: boolean;
    /**
     * 수요일 상담 가능 여부
     * @example true
     */
    wednesdayAvailable: boolean;
    /**
     * 목요일 상담 가능 여부
     * @example true
     */
    thursdayAvailable: boolean;
    /**
     * 금요일 상담 가능 여부
     * @example true
     */
    fridayAvailable: boolean;
    /**
     * 토요일 상담 가능 여부
     * @example true
     */
    saturdayAvailable: boolean;
  };
  /**
   * 상담 가능 요일 및 시간 정보
   * @example [{"dayIndex":1,"startedAt":"2025-01-01T09:00:00.000+0900","endedAt":"2025-01-01T18:00:00.000+0900"}]
   */
  careSchedule?:
    | {
        /**
         * 요일 인덱스
         * @example 0
         */
        dayIndex: number;
        /**
         * 상담 시작 시간
         * @format date
         * @example "2025-01-01T09:00:00.000+0900"
         */
        startedAt: string;
        /**
         * 상담 종료 시간
         * @format date
         * @example "2025-01-01T18:00:00.000+0900"
         */
        endedAt: string;
      }[]
    | null;
}

export interface KakaoConsultationTalkLinkageHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 연동 요청 성공 여부 */
    isLinkedSuccess: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface LineChannelInfoHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 라인 연동 요청자 ID
     * @example "63d7bafc1374672f7c407efd"
     */
    requesterID: string;
    /**
     * 라인 연동 요청자 이름
     * @example "홍길동"
     */
    requesterName: string;
    /**
     * 라인 연동 요청자 연락처
     * @example "010-1234-5678"
     */
    requesterContact: string;
    /**
     * 라인 연동 요청 최대 채널 수
     * @example 10
     */
    maximumLineAccountCount: number;
    /**
     * 라인 연동 요청 여부
     * @example true
     */
    isRequested: boolean;
    /**
     * 라인 연동 요청 승인 여부
     * @example true
     */
    isRequestApproved: boolean;
    /** 라인 채널 정보 */
    lineConsultMaps?: {
      /**
       * 라인 채널 ID
       * @example "63d7bafc1374672f7c407efd"
       */
      _id: string;
      /**
       * 라인 채널 이름
       * @example "라인 채널 이름"
       */
      lineChannelName: string;
      /**
       * 라인 봇 ID
       * @example "63d7bafc1374672f7c407efd"
       */
      lineBotID: string;
      /**
       * 라인 프리미엄 봇 ID
       * @example "63d7bafc1374672f7c407efd"
       */
      linePremiumBotID: string;
      /**
       * 라인 채널 삭제 여부
       * @example true
       */
      isRemoved: boolean;
      /**
       * 라인 웹훅 URL
       * @example "https://dev.line.afterdoc.net/line/chat/receive?serialNumber=123456"
       */
      webhookUrl: string;
    }[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface LineEnrollHandlerBodyRequest {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
  /**
   * 채널 ID
   * @example "123456"
   */
  channelID: string;
  /**
   * 채널 시크릿
   * @example "123456"
   */
  channelSecret: string;
  /**
   * 봇 기본 ID
   * @example "123456"
   */
  botBasicID: string;
  /**
   * 라인 채널 액세스 토큰
   * @example "123456"
   */
  lineChannelAccessToken: string;
}

export interface LineEnrollHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 라인 연동 성공 여부
     * @example true
     */
    isEnrolled: boolean;
    /**
     * 라인 웹훅 URL
     * @example "https://dev.line.afterdoc.net/line/chat/receive?serialNumber=123456"
     */
    webhookUrl: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface LineEnrollHistoryHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    lineEnrollChannelCountHistories: {
      /**
       * 라인 연동 요청 이력 ID
       * @example "63d7bafc1374672f7c407efd"
       */
      _id: string;
      /**
       * 사용자 이름
       * @example "홍길동"
       */
      userName: string;
      /**
       * 채널 수
       * @example 10
       */
      count: number;
      /**
       * 이유
       * @example "테스트"
       */
      reason: string;
      /**
       * 생성 일시
       * @format date
       * @example "2025-01-01T00:00:00.000Z"
       */
      createdAt: string;
    }[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface LineEnrollRequestHandlerBodyRequest {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
  /**
   * 이름
   * @example "홍길동"
   */
  name: string;
  /**
   * 전화번호
   * @example "010-1234-5678"
   */
  phone: string;
  /**
   * 라인 비즈니스 이메일
   * @example "test@test.com"
   */
  lineBusinessEmail?: string;
  /**
   * 연동 시작 희망 일시
   * @format date
   * @example "2025-01-01T00:00:00.000Z"
   */
  startDate: string;
}

export interface LineEnrollRequestHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 라인 연동 요청 성공 여부 */
    isEnrollSuccess: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface LineUnlinkHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 해제 여부
     * @example true
     */
    isUnlinked: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface InstagramAccountStatusRenewingBatchHandlerBodyRequest {
  /**
   * 대상 병원 ID 목록
   * @example ["63d7bafc1374672f7c407efd"]
   */
  targetHospitals?: string[];
}

export interface InstagramAccountStatusRenewingBatchHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  /** @example {"isProcessing":true} */
  data: {
    /** @default true */
    isProcessing: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface TalkTalkChannelEnrollHandlerBodyRequest {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
  /**
   * 톡톡 비즈센터 ID
   * @example "xxxxxx"
   */
  talktalkBusinessCenterID: string;
  /**
   * 인증 코드
   * @example "xxxxxx"
   */
  authorization: string;
}

export interface TalkTalkChannelEnrollHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 톡톡 웹훅 URL
     * @example "https://example.com/talktalk/webhook?serialNumber=xxxx"
     */
    webhookURL: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface TalkTalkChannelInfoHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 톡톡 연동 요청자 ID
     * @example "63d7bafc1374672f7c407efd"
     */
    requesterID: string;
    /**
     * 톡톡 연동 요청자 이름
     * @example "홍길동"
     */
    requesterName: string;
    /**
     * 톡톡 연동 요청자 연락처
     * @example "010-1234-5678"
     */
    requesterContact: string;
    /**
     * 최대 톡톡 채널 수
     * @example 3
     */
    maximumTalkTalkAccountCount: number;
    /**
     * 톡톡 연동 요청 여부
     * @example true
     */
    isRequested: boolean;
    /**
     * 톡톡 연동 요청 승인 여부
     * @example true
     */
    isRequestApproved: boolean;
    talktalkConsultMap: {
      /**
       * 톡톡 상담 매핑 ID
       * @example "63d7bafc1374672f7c407efd"
       */
      _id: string;
      /**
       * 톡톡 비즈니스 센터 ID
       * @example "63d7bafc1374672f7c407efd"
       */
      talktalkBusinessCenterID: string;
      /**
       * 톡톡 인증 키
       * @example "63d7bafc1374672f7c407efd"
       */
      authorization: string;
      /**
       * 톡톡 웹훅 URL
       * @example "https://example.com/talktalk/webhook?serialNumber=xxxx"
       */
      webhookURL: string;
    };
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface TalkTalkEnrollRequestHandlerBodyRequest {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
  /**
   * 사용자 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  userID: string;
  /**
   * 사용자 이름
   * @example "홍길동"
   */
  name: string;
  /**
   * 사용자 전화번호
   * @example "010-1234-5678"
   */
  phone: string;
  /**
   * 연동 시작 일시
   * @example "2025-01-01T00:00:00.000Z"
   */
  startDate: string;
}

export interface TalkTalkEnrollRequestHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 톡톡 연동 요청 성공 여부
     * @example true
     */
    isEnrolledSuccess: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface TalkTalkUnlinkHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data?: Record<string, any>;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatAssignedCounselorHandlerBodyRequest {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
  /**
   * 담당자 ID 목록
   * @example ["63d7bafc1374672f7c407efd"]
   */
  counselorIds: string[];
  /**
   * 계정 ID (인스타그램용)
   * @example "63d7bafc1374672f7c407efd"
   */
  accountID?: string;
  /**
   * 연동 ID (왓츠앱용)
   * @example "63d7bafc1374672f7c407efd"
   */
  linkageID?: string;
  /**
   * 상담 맵 ID (라인용)
   * @example "63d7bafc1374672f7c407efd"
   */
  consultMapID?: string;
}

export interface ChatAssignedCounselorHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 지정 담당자 수정 성공 여부
     * @example true
     */
    isUpdatedSuccess: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface FindChatAssignedCounselorHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 인스타그램 연동 계정 정보 목록 */
    instagramAccounts?:
      | {
          /**
           * 인스타그램 연동 계정 ID
           * @example "63d7bafc1374672f7c407efd"
           */
          id: string;
          /**
           * 인스타그램 계정 ID
           * @example "63d7bafc1374672f7c407efd"
           */
          accountID: string;
          /**
           * 인스타그램 로그인 ID
           * @example "@afterdoc.medipal"
           */
          instagramLoginID: string;
          /**
           * 인스타그램 계정 이름
           * @example "홍길동"
           */
          channelName: string;
          /** 상담사 정보 목록 */
          counselors?: {
            /**
             * 상담사 ID
             * @example "63d7bafc1374672f7c407efd"
             */
            id: string;
            /**
             * 상담사 이름
             * @example "홍길동"
             */
            realName: string;
          }[];
        }[]
      | null;
    /** 카카오톡 연동 정보 */
    ikakaoconsultMap?: {
      /**
       * 카카오톡 연동 계정 ID
       * @example "63d7bafc1374672f7c407efd"
       */
      id: string;
      /**
       * 카카오 상담톡 검색용 아이디
       * @example "홍길동"
       */
      channelName: string;
      /** 상담사 정보 목록 */
      counselors?: {
        /**
         * 상담사 ID
         * @example "63d7bafc1374672f7c407efd"
         */
        id: string;
        /**
         * 상담사 이름
         * @example "홍길동"
         */
        realName: string;
      }[];
    } | null;
    /** 톡톡 연동 정보 */
    talkTalkConsultMap?: {
      /**
       * 톡톡 연동 계정 ID
       * @example "63d7bafc1374672f7c407efd"
       */
      id: string;
      /**
       * 톡톡 채널 이름(톡톡은 고정적으로 네이버 톡톡으로 반환)
       * @example "홍길동"
       */
      channelName: string;
      /** 상담사 정보 목록 */
      counselors?: {
        /**
         * 상담사 ID
         * @example "63d7bafc1374672f7c407efd"
         */
        id: string;
        /**
         * 상담사 이름
         * @example "홍길동"
         */
        realName: string;
      }[];
    } | null;
    /** 라인 연동 정보 */
    lineConsultMaps?:
      | {
          /**
           * 라인 연동 계정 ID
           * @example "63d7bafc1374672f7c407efd"
           */
          id: string;
          /**
           * 라인 채널 이름
           * @example "라인 채널 이름"
           */
          channelName: string;
          /** 상담사 정보 목록 */
          counselors?: {
            /**
             * 상담사 ID
             * @example "63d7bafc1374672f7c407efd"
             */
            id: string;
            /**
             * 상담사 이름
             * @example "홍길동"
             */
            realName: string;
          }[];
        }[]
      | null;
    /** 웹챗 연동 정보 */
    wechatChannelLinkage?: {
      /**
       * 웹챗 연동 계정 ID
       * @example "63d7bafc1374672f7c407efd"
       */
      id: string;
      /**
       * 위챗 채널명
       * @example "홍길동"
       */
      channelName: string;
      /** 상담사 정보 목록 */
      counselors?: {
        /**
         * 상담사 ID
         * @example "63d7bafc1374672f7c407efd"
         */
        id: string;
        /**
         * 상담사 이름
         * @example "홍길동"
         */
        realName: string;
      }[];
    } | null;
    /** 왓츠앱 연동 정보 */
    whatsappChannelLinkages?:
      | {
          /**
           * 왓츠앱 연동 계정 ID
           * @example "63d7bafc1374672f7c407efd"
           */
          id: string;
          /**
           * 왓츠앱 채널 이름
           * @example "왓츠앱 채널 이름"
           */
          channelName: string;
          /**
           * 왓츠앱 채널 전화번호
           * @example "010-1234-5678"
           */
          displayPhoneNumber: string;
          /** 상담사 정보 목록 */
          counselors?: {
            /**
             * 상담사 ID
             * @example "63d7bafc1374672f7c407efd"
             */
            id: string;
            /**
             * 상담사 이름
             * @example "홍길동"
             */
            realName: string;
          }[];
        }[]
      | null;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface SocialChannelHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 아이카카오 채널 리스트 */
    ikakao: {
      /**
       * 카카오 플러스친구 ID
       * @example "_xnTaKxj"
       */
      pf_id?: string;
    }[];
    /** 라인 채널 리스트 */
    line: {
      /** 라인 봇 ID */
      lineBotID?: string;
      /** 라인 채널 이름 */
      lineChannelName?: string;
    }[];
    /** 인스타그램 채널 리스트 */
    instagram: {
      /** 인스타그램 로그인 ID */
      instagramLoginID?: string;
      /** 인스타그램 전체 이름 */
      instagramFullName?: string;
    }[];
    /** 톡톡 채널 리스트 */
    talktalk: {
      /** 톡톡 비즈니스 센터 ID */
      talktalkBusinessCenterID?: string;
    }[];
    /** 왓츠앱 채널 리스트 */
    whatsapp: {
      /** 왓츠앱 전화번호 ID */
      channelID?: string;
      /** 왓츠앱 채널 이름 */
      channelName?: string;
    }[];
    /** 위챗 채널 리스트 */
    wechat: {
      /** 위챗 채널 ID */
      channelID?: string;
      /** 위챗 채널 이름 */
      channelName?: string;
    }[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface SocialChannelHMHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 아이카카오 채널 리스트 */
    ikakao: {
      /**
       * 카카오 플러스친구 ID
       * @example "_xnTaKxj"
       */
      pf_id?: string;
    }[];
    /** 라인 채널 리스트 */
    line: {
      /** 라인 봇 ID */
      lineBotID?: string;
      /** 라인 채널 이름 */
      lineChannelName?: string;
    }[];
    /** 인스타그램 채널 리스트 */
    instagram: {
      /** 인스타그램 로그인 ID */
      instagramLoginID?: string;
      /** 인스타그램 전체 이름 */
      instagramFullName?: string;
    }[];
    /** 톡톡 채널 리스트 */
    talktalk: {
      /** 톡톡 비즈니스 센터 ID */
      talktalkBusinessCenterID?: string;
    }[];
    /** 왓츠앱 채널 리스트 */
    whatsapp: {
      /** 왓츠앱 전화번호 ID */
      channelID?: string;
      /** 왓츠앱 채널 이름 */
      channelName?: string;
    }[];
    /** 위챗 채널 리스트 */
    wechat: {
      /** 위챗 채널 ID */
      channelID?: string;
      /** 위챗 채널 이름 */
      channelName?: string;
    }[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ApiServiceSettingsElFindParams {
  /** (required) 병원ID */
  hospitalID?: string;
  /** 샘플 여부. */
  isSample?: boolean;
  /** 삭제 여부 */
  isRemoved?: boolean;
}

export type ApiServiceSettingsElFindData = ApiResponse & {
  data: ServiceSetting;
};

export interface ApiServiceSettingsElFindOneParams {
  /** (required) 병원ID */
  hospitalID?: string;
  /** 샘플 여부. */
  isSample?: boolean;
  /** 삭제 여부 */
  isRemoved?: boolean;
}

export type ApiServiceSettingsElFindOneData = ApiResponse & {
  data: ServiceSetting;
};

export type ApiServiceSettingsElCreateData = ApiResponse & {
  data: ServiceSettingSimple;
};

export type ApiServiceSettingsElUpdateData = ApiResponse & {
  data: ServiceSettingSimple;
};

export interface ApiServiceSettingsElToBeDisplayedPatientsFieldsParams {
  /** 병원 ID (필수) */
  hospitalID: string;
}

export type ApiServiceSettingsElToBeDisplayedPatientsFieldsData = ApiResponse & {
  data: {
    /** 국가번호 사용 여부 */
    usingCountryCode?: boolean;
    /** 생년월일 사용 여부 */
    usingBirthDay?: boolean;
    /** 성별 사용 여부 */
    usingGender?: boolean;
    /** 치료태그 사용 여부 */
    usingTreatmentTag?: boolean;
    /** 고객태그 사용 여부 */
    usingUserTag?: boolean;
    /** 초진/재진 사용 여부 */
    usingFirstVisitStartDate?: boolean;
    /** 차트번호 사용 여부 */
    usingChartNumber?: boolean;
    /** 국적 사용 여부 */
    usingNationality?: boolean;
    /** 광고성문자 수신 동의 사용 여부 */
    usingAdSMSConsent?: boolean;
    /** 사용 중인 필드명 리스트 */
    usingFieldNames?: string[];
  };
};

export interface ApiServiceSettingsElCountriesParams {
  /** 병원 ID */
  hospitalID: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /**
   * 조회하고자 하는 총 데이터 갯수. 빈 값일 경우 30
   * @default 30
   */
  limit?: number;
  /**
   * 정렬하고자 하는 field. 빈 값일 경우 _id로 정렬
   * @default "_id"
   */
  key?: string;
  /**
   * 정렬하고자 하는 방향. 1 오름차순, -1 내림차순. 빈 값일 경우 1
   * @default 1
   */
  way?: number;
}

export type ApiServiceSettingsElCountriesData = ApiResponse & {
  data: {
    /** 국가 고유 ID */
    countryId?: string;
    /** 한국어 국가명 */
    koreanCountryName?: string;
    /** 국제 전화 코드 */
    internationalDialingCodes?: string;
    /** ISO 3166-1 alpha-2 국가 코드 */
    countryCodeISOAlpha2?: string;
    /** ISO 3166-1 alpha-3 국가 코드 */
    countryCodeISOAlpha3?: string;
    /** 영어 국가명 */
    englishCountryName?: string;
  }[];
};

export interface ApiServiceSettingsHmFindOneParams {
  /** (required) 병원ID */
  hospitalID?: string;
}

export type ApiServiceSettingsHmFindOneData = any;

export interface ApiServiceSettingsHmCountriesParams {
  /** 병원 ID */
  hospitalID: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /**
   * 조회하고자 하는 총 데이터 갯수. 빈 값일 경우 30
   * @default 30
   */
  limit?: number;
  /**
   * 정렬하고자 하는 field. 빈 값일 경우 _id로 정렬
   * @default "_id"
   */
  key?: string;
  /**
   * 정렬하고자 하는 방향. 1 오름차순, -1 내림차순. 빈 값일 경우 1
   * @default 1
   */
  way?: number;
}

export type ApiServiceSettingsHmCountriesData = ApiResponse & {
  data: {
    /** 국가 고유 ID */
    countryId?: string;
    /** 한국어 국가명 */
    koreanCountryName?: string;
    /** 국제 전화 코드 */
    internationalDialingCodes?: string;
    /** ISO 3166-1 alpha-2 국가 코드 */
    countryCodeISOAlpha2?: string;
    /** ISO 3166-1 alpha-3 국가 코드 */
    countryCodeISOAlpha3?: string;
    /** 영어 국가명 */
    englishCountryName?: string;
  }[];
};

export type KaKaoControllerFindLinkageInfoData = KaKaoControllerFindLinkageInfoResponse;

export type KaKaoControllerRequestSetupData = KaKaoControllerRequestSetupResponse;

export interface WechatControllerFindLinkageInfoParams {
  hospitalID: string;
}

export type WechatControllerFindLinkageInfoData = WechatControllerFindLinkageInfoResponse;

export interface WechatControllerUnlinkLinkageParams {
  _id: string;
}

export type WechatControllerUnlinkLinkageData = WechatControllerUnlinkLinkageResponse;

export type WechatControllerHandleData = WechatControllerHandleResponse;

export interface WhatsappControllerFindLinkageInfoParams {
  hospitalID: string;
}

export type WhatsappControllerFindLinkageInfoData = WhatsappControllerFindLinkageInfoResponse;

export interface WhatsappControllerUnlinkLinkageParams {
  _id: string;
}

export type WhatsappControllerUnlinkLinkageData = WhatsappControllerUnlinkLinkageResponse;

export type WhatsappControllerHandleData = WhatsappControllerHandleResponse;

export type InstagramControllerUpdateInstagramAccountStatusData =
  InstagramControllerUpdateInstagramAccountStatusResponse;

export interface InstagramControllerFindInstagramAccountsParams {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
}

export type InstagramControllerFindInstagramAccountsData = InstagramControllerFindInstagramAccountsResponse;

export interface InstagramAccountsHandlerParams {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
}

export type InstagramAccountsHandlerData = InstagramAccountsHandlerResponse;

export interface KakaoLatestLinkageHistoryHandlerParams {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
  /**
   * 연동 이력 요청 타입 - ALIM_TALK: 알림톡 및 친구톡, CONSULTATION_TALK: 상담톡
   * @example "ALIM_TALK"
   */
  linkageType: "ALIM_TALK" | "CONSULTATION_TALK";
}

export type KakaoLatestLinkageHistoryHandlerData = KakaoLatestLinkageHistoryHandlerResponse;

export type KakaoProfileCategoryHandlerData = KakaoProfileCategoryHandlerResponse;

export type InstagramAccountLinkageHandlerData = InstagramAccountLinkageHandlerResponse;

export type InstagramDisconnectionHandlerData = InstagramDisconnectionHandlerResponse;

export type InstagramLinkageHandlerData = InstagramLinkageHandlerResponse;

export type KakaoAlimFriendTalkLinkageHandlerData = KakaoAlimFriendTalkLinkageHandlerResponse;

export type KakaoAuthenticationNumberHandlerData = KakaoAuthenticationNumberHandlerResponse;

export type KakaoConsultationTalkLinkageHandlerData = KakaoConsultationTalkLinkageHandlerResponse;

export interface LineChannelInfoHandlerParams {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
}

export type LineChannelInfoHandlerData = LineChannelInfoHandlerResponse;

export type LineEnrollHandlerData = LineEnrollHandlerResponse;

export interface LineEnrollHistoryHandlerParams {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
}

export type LineEnrollHistoryHandlerData = LineEnrollHistoryHandlerResponse;

export type LineEnrollRequestHandlerData = LineEnrollRequestHandlerResponse;

export interface LineUnlinkHandlerParams {
  lineConsultMapID: string;
}

export type LineUnlinkHandlerData = LineUnlinkHandlerResponse;

export type InstagramAccountStatusRenewingBatchHandlerData = InstagramAccountStatusRenewingBatchHandlerResponse;

export type TalkTalkChannelEnrollHandlerData = TalkTalkChannelEnrollHandlerResponse;

export interface TalkTalkChannelInfoHandlerParams {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
}

export type TalkTalkChannelInfoHandlerData = TalkTalkChannelInfoHandlerResponse;

export type TalkTalkEnrollRequestHandlerData = TalkTalkEnrollRequestHandlerResponse;

export interface TalkTalkUnlinkHandlerParams {
  talktalkConsultMapID: string;
}

export type TalkTalkUnlinkHandlerData = TalkTalkUnlinkHandlerResponse;

export interface ChatAssignedCounselorHandlerParams {
  /** 채널 종류 */
  channel: "kakaotalk" | "line" | "instagram" | "talktalk" | "wechat" | "whatsapp";
}

export type ChatAssignedCounselorHandlerData = ChatAssignedCounselorHandlerResponse;

export interface FindChatAssignedCounselorHandlerParams {
  /** 병원 ID */
  hospitalID: string;
}

export type FindChatAssignedCounselorHandlerData = FindChatAssignedCounselorHandlerResponse;

export type SocialChannelHandlerData = SocialChannelHandlerResponse;

export type SocialChannelHmHandlerData = SocialChannelHMHandlerResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * No description
     *
     * @tags V3-ServiceSetting
     * @name ApiServiceSettingsElFind
     * @summary 서비스 설정(ServiceSetting) 조회
     * @request GET:/v3/api/service-settings/el/find
     * @secure
     * @response `200` `ApiServiceSettingsElFindData` 서비스 설정 조회 성공
     */
    apiServiceSettingsElFind: (query: ApiServiceSettingsElFindParams, params: RequestParams = {}) =>
      this.request<ApiServiceSettingsElFindData, any>({
        path: `/v3/api/service-settings/el/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ServiceSetting
     * @name ApiServiceSettingsElFindOne
     * @summary 서비스 설정(ServiceSetting) 조회
     * @request GET:/v3/api/service-settings/el/find/one
     * @secure
     * @response `200` `ApiServiceSettingsElFindOneData` 서비스 설정 조회 성공
     */
    apiServiceSettingsElFindOne: (query: ApiServiceSettingsElFindOneParams, params: RequestParams = {}) =>
      this.request<ApiServiceSettingsElFindOneData, any>({
        path: `/v3/api/service-settings/el/find/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ServiceSetting
     * @name ApiServiceSettingsElCreate
     * @summary 서비스 설정(ServiceSetting) 생성
     * @request POST:/v3/api/service-settings/el/create
     * @secure
     * @response `200` `ApiServiceSettingsElCreateData` 서비스 설정 생성 성공
     */
    apiServiceSettingsElCreate: (
      data: ServiceSettingSimple & {
        createdAt?: string;
        updatedAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiServiceSettingsElCreateData, any>({
        path: `/v3/api/service-settings/el/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ServiceSetting
     * @name ApiServiceSettingsElUpdate
     * @summary 서비스 설정(ServiceSetting) 수정
     * @request POST:/v3/api/service-settings/el/update
     * @secure
     * @response `200` `ApiServiceSettingsElUpdateData` 서비스 설정 수정 성공
     */
    apiServiceSettingsElUpdate: (
      data: ServiceSettingSimple & {
        createdAt?: string;
        updatedAt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiServiceSettingsElUpdateData, any>({
        path: `/v3/api/service-settings/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 별 환자 정보가 출력될 필드 정보 리스트를 조회합니다.
     *
     * @tags V3-ServiceSetting
     * @name ApiServiceSettingsElToBeDisplayedPatientsFields
     * @summary 검색 필드명 리스트 조회 API
     * @request GET:/v3/api/service-settings/el/to-be-displayed-patients-fields
     * @secure
     * @response `200` `ApiServiceSettingsElToBeDisplayedPatientsFieldsData` 병원 별 환자 정보가 출력될 필드 정보 리스트 조회 성공
     */
    apiServiceSettingsElToBeDisplayedPatientsFields: (
      query: ApiServiceSettingsElToBeDisplayedPatientsFieldsParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiServiceSettingsElToBeDisplayedPatientsFieldsData, any>({
        path: `/v3/api/service-settings/el/to-be-displayed-patients-fields`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 병원에서 지원하는 국적 및 국가 번호 리스트를 조회합니다.
     *
     * @tags V3-ServiceSetting
     * @name ApiServiceSettingsElCountries
     * @summary 병원 별 지원하는 국적 및 국가 번호 리스트 조회 API
     * @request GET:/v3/api/service-settings/el/countries
     * @secure
     * @response `200` `ApiServiceSettingsElCountriesData` 병원에서 사용하는 국가번호 또는 국적 조회 성공
     */
    apiServiceSettingsElCountries: (query: ApiServiceSettingsElCountriesParams, params: RequestParams = {}) =>
      this.request<ApiServiceSettingsElCountriesData, any>({
        path: `/v3/api/service-settings/el/countries`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ServiceSetting
     * @name ApiServiceSettingsHmFindOne
     * @summary 병원 상담 모바일 앱 - 서비스 설정(ServiceSetting) 조회
     * @request GET:/v3/api/service-settings/hm/find/one
     * @secure
     * @response `200` `ApiServiceSettingsHmFindOneData` \{ServiceSetting\} 객체
     */
    apiServiceSettingsHmFindOne: (query: ApiServiceSettingsHmFindOneParams, params: RequestParams = {}) =>
      this.request<ApiServiceSettingsHmFindOneData, any>({
        path: `/v3/api/service-settings/hm/find/one`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description 특정 병원에서 지원하는 국적 및 국가 번호 리스트를 조회합니다.
     *
     * @tags V3-ServiceSetting
     * @name ApiServiceSettingsHmCountries
     * @summary 병원 상담 모바일 앱 - 병원 별 지원하는 국적 및 국가 번호 리스트 조회 API
     * @request GET:/v3/api/service-settings/hm/countries
     * @secure
     * @response `200` `ApiServiceSettingsHmCountriesData` 병원에서 사용하는 국가번호 또는 국적 조회 성공
     */
    apiServiceSettingsHmCountries: (query: ApiServiceSettingsHmCountriesParams, params: RequestParams = {}) =>
      this.request<ApiServiceSettingsHmCountriesData, any>({
        path: `/v3/api/service-settings/hm/countries`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 연동 정보를 조회합니다
     *
     * @tags V3-ServiceSetting
     * @name KaKaoControllerFindLinkageInfo
     * @summary 카카오 연동 정보 조회
     * @request GET:/v3/api/service-settings/el/kakao/link
     * @secure
     * @response `200` `KaKaoControllerFindLinkageInfoData` success
     */
    kaKaoControllerFindLinkageInfo: (params: RequestParams = {}) =>
      this.request<KaKaoControllerFindLinkageInfoData, any>({
        path: `/v3/api/service-settings/el/kakao/link`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 연동 기능을 사용할 수 있도록 신청합니다
     *
     * @tags V3-ServiceSetting
     * @name KaKaoControllerRequestSetup
     * @summary 카카오 연동 기능 활성화 신청
     * @request POST:/v3/api/service-settings/el/kakao/setup
     * @secure
     * @response `200` `KaKaoControllerRequestSetupData` success
     */
    kaKaoControllerRequestSetup: (data: KaKaoControllerRequestSetupBodyRequest, params: RequestParams = {}) =>
      this.request<KaKaoControllerRequestSetupData, any>({
        path: `/v3/api/service-settings/el/kakao/setup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 위챗 연동 정보를 조회합니다
     *
     * @tags V3-ServiceSetting
     * @name WechatControllerFindLinkageInfo
     * @summary 위챗 연동 정보 조회
     * @request GET:/v3/api/service-settings/el/wechat/link
     * @secure
     * @response `200` `WechatControllerFindLinkageInfoData` success
     */
    wechatControllerFindLinkageInfo: (query: WechatControllerFindLinkageInfoParams, params: RequestParams = {}) =>
      this.request<WechatControllerFindLinkageInfoData, any>({
        path: `/v3/api/service-settings/el/wechat/link`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 위챗 채널 연동을 해제합니다
     *
     * @tags V3-ServiceSetting
     * @name WechatControllerUnlinkLinkage
     * @summary 위챗 채널 연동 해제
     * @request DELETE:/v3/api/service-settings/el/wechat/link
     * @secure
     * @response `200` `WechatControllerUnlinkLinkageData` success
     */
    wechatControllerUnlinkLinkage: (query: WechatControllerUnlinkLinkageParams, params: RequestParams = {}) =>
      this.request<WechatControllerUnlinkLinkageData, any>({
        path: `/v3/api/service-settings/el/wechat/link`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 위챗 연동 기능을 사용할 수 있도록 신청합니다
     *
     * @tags V3-ServiceSetting
     * @name WechatControllerHandle
     * @summary 위챗 연동 기능 활성화 신청
     * @request POST:/v3/api/service-settings/el/wechat/setup
     * @secure
     * @response `200` `WechatControllerHandleData` success
     */
    wechatControllerHandle: (data: WechatControllerHandleBodyRequest, params: RequestParams = {}) =>
      this.request<WechatControllerHandleData, any>({
        path: `/v3/api/service-settings/el/wechat/setup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 왓츠앱 연동 정보를 조회합니다
     *
     * @tags V3-ServiceSetting
     * @name WhatsappControllerFindLinkageInfo
     * @summary 왓츠앱 연동 정보 조회
     * @request GET:/v3/api/service-settings/el/whatsapp/link
     * @secure
     * @response `200` `WhatsappControllerFindLinkageInfoData` success
     */
    whatsappControllerFindLinkageInfo: (query: WhatsappControllerFindLinkageInfoParams, params: RequestParams = {}) =>
      this.request<WhatsappControllerFindLinkageInfoData, any>({
        path: `/v3/api/service-settings/el/whatsapp/link`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 왓츠앱 채널 연동을 해제합니다
     *
     * @tags V3-ServiceSetting
     * @name WhatsappControllerUnlinkLinkage
     * @summary 왓츠앱 채널 연동 해제
     * @request DELETE:/v3/api/service-settings/el/whatsapp/link
     * @secure
     * @response `200` `WhatsappControllerUnlinkLinkageData` success
     */
    whatsappControllerUnlinkLinkage: (query: WhatsappControllerUnlinkLinkageParams, params: RequestParams = {}) =>
      this.request<WhatsappControllerUnlinkLinkageData, any>({
        path: `/v3/api/service-settings/el/whatsapp/link`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 왓츠앱 연동 기능을 사용할 수 있도록 신청합니다
     *
     * @tags V3-ServiceSetting
     * @name WhatsappControllerHandle
     * @summary 왓츠앱 연동 기능 활성화 신청
     * @request POST:/v3/api/service-settings/el/whatsapp/setup
     * @secure
     * @response `200` `WhatsappControllerHandleData` success
     */
    whatsappControllerHandle: (data: WhatsappControllerHandleBodyRequest, params: RequestParams = {}) =>
      this.request<WhatsappControllerHandleData, any>({
        path: `/v3/api/service-settings/el/whatsapp/setup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 인스타그램 계정 상태를 갱신합니다.
     *
     * @tags V3-ServiceSetting
     * @name InstagramControllerUpdateInstagramAccountStatus
     * @summary 인스타그램 계정 상태 갱신
     * @request POST:/v3/api/service-settings/instagram-accounts/status/batch
     * @secure
     * @response `200` `InstagramControllerUpdateInstagramAccountStatusData` success
     */
    instagramControllerUpdateInstagramAccountStatus: (params: RequestParams = {}) =>
      this.request<InstagramControllerUpdateInstagramAccountStatusData, any>({
        path: `/v3/api/service-settings/instagram-accounts/status/batch`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 별로 인스타그램 연동 계정들을 조회합니다.
     *
     * @tags V3-ServiceSetting
     * @name InstagramControllerFindInstagramAccounts
     * @summary 병원 별 인스타그램 연동 계정 조회
     * @request GET:/v3/api/service-settings/instagram-accounts
     * @secure
     * @response `200` `InstagramControllerFindInstagramAccountsData` success
     */
    instagramControllerFindInstagramAccounts: (
      query: InstagramControllerFindInstagramAccountsParams,
      params: RequestParams = {},
    ) =>
      this.request<InstagramControllerFindInstagramAccountsData, any>({
        path: `/v3/api/service-settings/instagram-accounts`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 별로 인스타그램 연동 계정들을 조회합니다.
     *
     * @tags V3-ServiceSetting
     * @name InstagramAccountsHandler
     * @summary 병원 별 인스타그램 연동 계정 조회
     * @request GET:/v3/api/service-settings/el/instagram-accounts
     * @deprecated
     * @secure
     * @response `200` `InstagramAccountsHandlerData` success
     */
    instagramAccountsHandler: (query: InstagramAccountsHandlerParams, params: RequestParams = {}) =>
      this.request<InstagramAccountsHandlerData, any>({
        path: `/v3/api/service-settings/el/instagram-accounts`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 별로 가장 최근에 요청한 카카오 연동 이력을 조회합니다.
     *
     * @tags V3-ServiceSetting
     * @name KakaoLatestLinkageHistoryHandler
     * @summary 병원 별 가장 최근 요청 카카오 연동 이력 조회
     * @request GET:/v3/api/service-settings/el/kakao-linkage-history
     * @secure
     * @response `200` `KakaoLatestLinkageHistoryHandlerData` success
     */
    kakaoLatestLinkageHistoryHandler: (query: KakaoLatestLinkageHistoryHandlerParams, params: RequestParams = {}) =>
      this.request<KakaoLatestLinkageHistoryHandlerData, any>({
        path: `/v3/api/service-settings/el/kakao-linkage-history`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 알림톡 및 친구톡 연동을 위한 프로필 카테고리를 조회합니다.
     *
     * @tags V3-ServiceSetting
     * @name KakaoProfileCategoryHandler
     * @summary 카카오 알림톡 및 친구톡 연동을 위한 프로필 카테고리 조회
     * @request GET:/v3/api/service-settings/kakao-profile-category
     * @secure
     * @response `200` `KakaoProfileCategoryHandlerData` success
     */
    kakaoProfileCategoryHandler: (params: RequestParams = {}) =>
      this.request<KakaoProfileCategoryHandlerData, any>({
        path: `/v3/api/service-settings/kakao-profile-category`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 인스타그램 계정 (재)연동을 신청합니다.
     *
     * @tags V3-ServiceSetting
     * @name InstagramAccountLinkageHandler
     * @summary 인스타그램 (재)연동 신청
     * @request POST:/v3/api/service-settings/el/instagram-account-linkage
     * @secure
     * @response `200` `InstagramAccountLinkageHandlerData` success
     */
    instagramAccountLinkageHandler: (data: InstagramAccountLinkageHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<InstagramAccountLinkageHandlerData, any>({
        path: `/v3/api/service-settings/el/instagram-account-linkage`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 인스타그램 특정 계정 연동을 해제합니다.
     *
     * @tags V3-ServiceSetting
     * @name InstagramDisconnectionHandler
     * @summary 인스타그램 특정 계정 연동 해제
     * @request PATCH:/v3/api/service-settings/el/instagram-account-disconnection
     * @secure
     * @response `200` `InstagramDisconnectionHandlerData` success
     */
    instagramDisconnectionHandler: (data: InstagramDisconnectionHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<InstagramDisconnectionHandlerData, any>({
        path: `/v3/api/service-settings/el/instagram-account-disconnection`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 인스타그램 연동을 신청합니다.
     *
     * @tags V3-ServiceSetting
     * @name InstagramLinkageHandler
     * @summary 인스타그램 연동 신청
     * @request POST:/v3/api/service-settings/el/instagram-linkage
     * @secure
     * @response `200` `InstagramLinkageHandlerData` success
     */
    instagramLinkageHandler: (data: InstagramLinkageHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<InstagramLinkageHandlerData, any>({
        path: `/v3/api/service-settings/el/instagram-linkage`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 알림톡 및 친구톡 연동을 신청합니다.
     *
     * @tags V3-ServiceSetting
     * @name KakaoAlimFriendTalkLinkageHandler
     * @summary 카카오 알림톡 및 친구톡 연동 신청
     * @request POST:/v3/api/service-settings/el/kakao-alim-frined-talk-linkage
     * @secure
     * @response `200` `KakaoAlimFriendTalkLinkageHandlerData` success
     */
    kakaoAlimFriendTalkLinkageHandler: (
      data: KakaoAlimFriendTalkLinkageHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<KakaoAlimFriendTalkLinkageHandlerData, any>({
        path: `/v3/api/service-settings/el/kakao-alim-frined-talk-linkage`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 알림톡 또는 친구톡 연동을 위한 인증번호를 요청합니다.
     *
     * @tags V3-ServiceSetting
     * @name KakaoAuthenticationNumberHandler
     * @summary 카카오 알림톡 또는 친구톡 연동을 위한 인증번호 요청
     * @request POST:/v3/api/service-settings/el/kakao-authentication-number/for-alimtalk-linkage
     * @secure
     * @response `200` `KakaoAuthenticationNumberHandlerData` success
     */
    kakaoAuthenticationNumberHandler: (data: KakaoAuthenticationNumberHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<KakaoAuthenticationNumberHandlerData, any>({
        path: `/v3/api/service-settings/el/kakao-authentication-number/for-alimtalk-linkage`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 카카오 상담톡 연동을 신청합니다.
     *
     * @tags V3-ServiceSetting
     * @name KakaoConsultationTalkLinkageHandler
     * @summary 카카오 상담톡 연동 신청
     * @request POST:/v3/api/service-settings/el/kakao-consultation-talk-linkage
     * @secure
     * @response `200` `KakaoConsultationTalkLinkageHandlerData` success
     */
    kakaoConsultationTalkLinkageHandler: (
      data: KakaoConsultationTalkLinkageHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<KakaoConsultationTalkLinkageHandlerData, any>({
        path: `/v3/api/service-settings/el/kakao-consultation-talk-linkage`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 라인 채널 정보
     *
     * @tags V3-ServiceSetting
     * @name LineChannelInfoHandler
     * @summary 라인 채널 정보
     * @request GET:/v3/api/service-settings/el/line/channel/info
     * @secure
     * @response `200` `LineChannelInfoHandlerData` success
     */
    lineChannelInfoHandler: (query: LineChannelInfoHandlerParams, params: RequestParams = {}) =>
      this.request<LineChannelInfoHandlerData, any>({
        path: `/v3/api/service-settings/el/line/channel/info`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 라인 채널을 연동합니다. 최대 연동 갯수를 넘어가면 채널 연동이 안됩니다
     *
     * @tags V3-ServiceSetting
     * @name LineEnrollHandler
     * @summary 라인 채널 연동
     * @request POST:/v3/api/service-settings/el/line/enroll
     * @secure
     * @response `200` `LineEnrollHandlerData` success
     */
    lineEnrollHandler: (data: LineEnrollHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<LineEnrollHandlerData, any>({
        path: `/v3/api/service-settings/el/line/enroll`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 라인 연동 요청 이력
     *
     * @tags V3-ServiceSetting
     * @name LineEnrollHistoryHandler
     * @summary 라인 연동 요청 이력
     * @request GET:/v3/api/service-settings/el/line/enroll/history
     * @secure
     * @response `200` `LineEnrollHistoryHandlerData` success
     */
    lineEnrollHistoryHandler: (query: LineEnrollHistoryHandlerParams, params: RequestParams = {}) =>
      this.request<LineEnrollHistoryHandlerData, any>({
        path: `/v3/api/service-settings/el/line/enroll/history`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 라인 연동을 신청합니다. 이미 있는경우에도 신청할 수 있으며, 이때는 연동 갯수 및 제공 값을 업데이트 합니다
     *
     * @tags V3-ServiceSetting
     * @name LineEnrollRequestHandler
     * @summary 라인 연동 신청
     * @request POST:/v3/api/service-settings/el/line/request
     * @secure
     * @response `200` `LineEnrollRequestHandlerData` success
     */
    lineEnrollRequestHandler: (data: LineEnrollRequestHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<LineEnrollRequestHandlerData, any>({
        path: `/v3/api/service-settings/el/line/request`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 라인 채널 연동을 해제합니다.
     *
     * @tags V3-ServiceSetting
     * @name LineUnlinkHandler
     * @summary 라인 채널 연동 해제
     * @request DELETE:/v3/api/service-settings/el/line/unlink
     * @secure
     * @response `200` `LineUnlinkHandlerData` success
     */
    lineUnlinkHandler: (query: LineUnlinkHandlerParams, params: RequestParams = {}) =>
      this.request<LineUnlinkHandlerData, any>({
        path: `/v3/api/service-settings/el/line/unlink`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 인스타그램 연동 계정들의 상태를 갱신합니다.
     *
     * @tags V3-ServiceSetting
     * @name InstagramAccountStatusRenewingBatchHandler
     * @summary 이 API는 더 이상 사용되지 않습니다. 대신 /v3/api/service-settings/instagram-accounts/status/batch 를 사용하세요.
     * @request POST:/v3/api/service-settings/el/instagram-accounts/status-renewing/batch
     * @deprecated
     * @secure
     * @response `200` `InstagramAccountStatusRenewingBatchHandlerData` success
     */
    instagramAccountStatusRenewingBatchHandler: (
      data: InstagramAccountStatusRenewingBatchHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<InstagramAccountStatusRenewingBatchHandlerData, any>({
        path: `/v3/api/service-settings/el/instagram-accounts/status-renewing/batch`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 톡톡 채널 등록(해제 후 재등록시 기존 톡톡 채팅방 채팅 금지(isClosed:true)를 해제합니다.
     *
     * @tags V3-ServiceSetting
     * @name TalkTalkChannelEnrollHandler
     * @summary 톡톡 채널 등록
     * @request POST:/v3/api/service-settings/el/talktalk/channel/enroll
     * @secure
     * @response `200` `TalkTalkChannelEnrollHandlerData` success
     */
    talkTalkChannelEnrollHandler: (data: TalkTalkChannelEnrollHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<TalkTalkChannelEnrollHandlerData, any>({
        path: `/v3/api/service-settings/el/talktalk/channel/enroll`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 톡톡 채널 정보 조회
     *
     * @tags V3-ServiceSetting
     * @name TalkTalkChannelInfoHandler
     * @summary 톡톡 채널 정보 조회
     * @request GET:/v3/api/service-settings/el/talktalk/channel/info
     * @secure
     * @response `200` `TalkTalkChannelInfoHandlerData` success
     */
    talkTalkChannelInfoHandler: (query: TalkTalkChannelInfoHandlerParams, params: RequestParams = {}) =>
      this.request<TalkTalkChannelInfoHandlerData, any>({
        path: `/v3/api/service-settings/el/talktalk/channel/info`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 톡톡 연동 요청
     *
     * @tags V3-ServiceSetting
     * @name TalkTalkEnrollRequestHandler
     * @summary 톡톡 연동 요청
     * @request POST:/v3/api/service-settings/el/talktalk/request
     * @secure
     * @response `200` `TalkTalkEnrollRequestHandlerData` success
     */
    talkTalkEnrollRequestHandler: (data: TalkTalkEnrollRequestHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<TalkTalkEnrollRequestHandlerData, any>({
        path: `/v3/api/service-settings/el/talktalk/request`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 톡톡 채널 연동을 해제합니다(해제 후 재연동시 기존 톡톡 채팅방 채팅 금지(isClosed:true)를 해제합니다.
     *
     * @tags V3-ServiceSetting
     * @name TalkTalkUnlinkHandler
     * @summary 톡톡 연동 해제
     * @request DELETE:/v3/api/service-settings/el/talktalk/link
     * @secure
     * @response `200` `TalkTalkUnlinkHandlerData` success
     */
    talkTalkUnlinkHandler: (query: TalkTalkUnlinkHandlerParams, params: RequestParams = {}) =>
      this.request<TalkTalkUnlinkHandlerData, any>({
        path: `/v3/api/service-settings/el/talktalk/link`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 채널별 지정 담당자 수정 (통합 API) channel: instagram, line, talktalk, whatsapp, wechat, kakaotalk [중요] Schema를 꼭 확인해주세요. (다채널의 경우 채널별로 다른 스키마를 사용합니다.) kakaotaolk, talktalk, wechat : hospitalID 필요 instagran: hospitalID, accountID 필요 line: hospitalID, consultMapID 필요 whatsapp: hospitalID, linkageID 필요
     *
     * @tags V3-ServiceSetting
     * @name ChatAssignedCounselorHandler
     * @summary 채널별 지정 담당자 수정 (통합 API)
     * @request PATCH:/v3/api/service-settings/el/counselor
     * @secure
     * @response `200` `ChatAssignedCounselorHandlerData` success
     */
    chatAssignedCounselorHandler: (
      query: ChatAssignedCounselorHandlerParams,
      data: ChatAssignedCounselorHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<ChatAssignedCounselorHandlerData, any>({
        path: `/v3/api/service-settings/el/counselor`,
        method: "PATCH",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 채널별 지정 담당자 조회 API
     *
     * @tags V3-ServiceSetting
     * @name FindChatAssignedCounselorHandler
     * @summary 채널별 지정 담당자 조회 API
     * @request GET:/v3/api/service-settings/el/counselor
     * @secure
     * @response `200` `FindChatAssignedCounselorHandlerData` success
     */
    findChatAssignedCounselorHandler: (query: FindChatAssignedCounselorHandlerParams, params: RequestParams = {}) =>
      this.request<FindChatAssignedCounselorHandlerData, any>({
        path: `/v3/api/service-settings/el/counselor`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 연동 채널 리스트를 반환합니다.
     *
     * @tags V3-ServiceSetting
     * @name SocialChannelHandler
     * @summary 연동된 소셜 미디어 채널 리스트 조회
     * @request GET:/v3/api/service-settings/el/social-channel
     * @secure
     * @response `200` `SocialChannelHandlerData` success
     */
    socialChannelHandler: (params: RequestParams = {}) =>
      this.request<SocialChannelHandlerData, any>({
        path: `/v3/api/service-settings/el/social-channel`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 상담 모바일 앱 - 연동 채널 리스트를 반환합니다.
     *
     * @tags V3-ServiceSetting
     * @name SocialChannelHmHandler
     * @summary 병원 상담 모바일 앱 - 연동된 소셜 미디어 채널 리스트 조회
     * @request GET:/v3/api/service-settings/hm/social-channel
     * @secure
     * @response `200` `SocialChannelHmHandlerData` success
     */
    socialChannelHmHandler: (params: RequestParams = {}) =>
      this.request<SocialChannelHmHandlerData, any>({
        path: `/v3/api/service-settings/hm/social-channel`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
